import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Home from './dashboard/Home';
import Profile from './dashboard/Profile';
import Settings from './dashboard/Settings';
import Analytics from './dashboard/Analytics';
import Reports from './dashboard/Reports';
import Invoices from './dashboard/Invoices';
import InvoiceForm from './dashboard/InvoiceForm';
import InvoiceEditForm from './dashboard/InvoiceEditForm';
import InvoiceSettings from './dashboard/InvoiceSettings';
import WebsiteSettings from './dashboard/WebsiteSettings';
import ContactInquiries from './dashboard/ContactInquiries';
import './Dashboard.css';

const Dashboard = () => {
  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="content-area">
          <Routes>
            <Route index element={<Home />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="invoices/create" element={<InvoiceForm />} />
            <Route path="invoices/edit/:id" element={<InvoiceEditForm />} />
            <Route path="invoice-settings" element={<InvoiceSettings />} />
            <Route path="website-settings" element={<WebsiteSettings />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="reports" element={<Reports />} />
            <Route path="contact-inquiries" element={<ContactInquiries />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
